import { IsInt, IsNotEmpty, IsNumber, IsOptional, IsPositive, IsString, MaxLength } from 'class-validator';

export class ApproveOperationDto {
  @IsInt()
  @IsNotEmpty()
  managerEmployeeId: number;

  @IsNumber()
  @IsPositive()
  @IsOptional()
  amount?: number;
  // If provided, this overrides the operator's count.
  // If null, we use the value from DB 'requestedAmount'.

  @IsString()
  @IsOptional()
  @MaxLength(500, { message: 'Note is too long. Maximum is 500 characters.' })
  note?: string;
}